import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { providersApi } from '../api/providers.api'
import { providersKeys } from './query-keys'

export type { ProviderFormData, ProviderRecord } from '../api/providers.api'

export const useProviders = () =>
	useQuery({
		queryKey: providersKeys.list(),
		queryFn: providersApi.list,
	})

export const useProvider = (providerId: string) =>
	useQuery({
		queryKey: providersKeys.detail(providerId),
		queryFn: () => providersApi.get(providerId),
		enabled: !!providerId,
	})

export const useCreateProvider = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: providersApi.create,
		onSuccess: () => void qc.invalidateQueries({ queryKey: providersKeys.all }),
	})
}

export const useUpdateProvider = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: providersApi.update,
		onSuccess: () => void qc.invalidateQueries({ queryKey: providersKeys.all }),
	})
}

export const useDeleteProvider = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: providersApi.delete,
		onSuccess: () => void qc.invalidateQueries({ queryKey: providersKeys.all }),
	})
}
